import React, { FC, useCallback, useRef, useState } from 'react';

import { Link } from 'react-router-dom';

import { LANDING } from '../../configs/api/api.config';
import { MenuMobile } from '../menu/menu-mobile';

const Header: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
    window.requestAnimationFrame(() => menuButtonRef.current?.focus());
  }, []);

  return (
    <header className="relative z-[999] h-headerHeightMobile w-full bg-white shadow-shadowHeader lg:h-headerHeight">
      <div className="mx-auto h-full w-full px-4 py-2 sm:px-[30px]">
        <div className="flex h-full items-center justify-between gap-3">
          <Link to={LANDING} className="flex min-w-0 shrink items-center gap-2 sm:gap-3">
            <span className="shrink-0 text-2xl font-bold leading-none text-red-600 sm:text-3xl md:text-4xl">ZiNGiZi</span>
            <span className="hidden flex-col justify-center gap-0.5 leading-tight sm:flex">
              <span className="whitespace-nowrap text-[10px] font-normal text-[#4F5D75] md:text-[11px] lg:text-sm">
                УМНЫЙ КАБИНЕТ ПСИХОЛОГА
              </span>
              <span className="whitespace-nowrap text-[10px] font-normal text-[#4F5D75] md:text-[11px] lg:text-sm">
                ЭТИЧНО | ТЕХНОЛОГИЧНО | ЧЕЛОВЕЧНО
              </span>
            </span>
          </Link>

          <div className="flex shrink-0 items-center gap-2 lg:hidden">
            <Link
              to="/profile"
              aria-label="Перейти в профиль"
              className="flex h-11 w-11 items-center justify-center text-[#111026] transition-colors hover:text-redBase focus-visible:ring-2 focus-visible:ring-redBase focus-visible:ring-offset-2"
            >
              <span className="material-symbols-outlined text-[28px] leading-none" aria-hidden="true">
                account_circle
              </span>
            </Link>
            <button
              ref={menuButtonRef}
              type="button"
              aria-label="Открыть меню"
              aria-expanded={isMenuOpen}
              aria-controls="mobile-navigation"
              onClick={() => setIsMenuOpen(true)}
              className="flex h-11 w-11 items-center justify-center rounded-[10px] text-[#111026] transition-colors hover:bg-[#F5F6FA] focus-visible:ring-2 focus-visible:ring-redBase focus-visible:ring-offset-2"
            >
              <MenuIcon />
            </button>
          </div>
        </div>
      </div>
      <MenuMobile openMenu={isMenuOpen} onCloseMenu={closeMenu} />
    </header>
  );
};

const MenuIcon = () => (
  <span className="flex flex-col gap-[5px]" aria-hidden="true">
    <span className="block h-[2px] w-6 rounded-full bg-current" />
    <span className="block h-[2px] w-6 rounded-full bg-current" />
    <span className="block h-[2px] w-6 rounded-full bg-current" />
  </span>
);

export default Header;
